export default __webpack_public_path__ + "43791d4f6a1abbbfe5a709d8810b7010.png";